/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import Box from '@atlaskit/primitives/box';
import Stack from '@atlaskit/primitives/stack';
import { xcss } from '@atlaskit/primitives/xcss';
import { token } from '@atlaskit/tokens';

export const Skeleton = (): React.JSX.Element => (
	<Stack space="space.100" grow="hug">
		<Box xcss={sectionHeading} />
		<Box xcss={menuItem} />
		<Box xcss={menuItem} />
		<Box xcss={menuItem} />

		<Box xcss={sectionHeading} />
		<Box xcss={menuItem} />
		<Box xcss={menuItem} />
		<Box xcss={menuItem} />
		<Box xcss={menuItem} />
	</Stack>
);

const sectionHeading = xcss({
	backgroundColor: 'color.skeleton',
	width: '50%',
	height: token('space.200'),
	borderRadius: 'radius.small',
	marginTop: 'space.100',
});

const menuItem = xcss({
	backgroundColor: 'color.skeleton',
	height: token('space.400'),
	borderRadius: 'radius.small',
});
